// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#policy_block {
   padding: 1em 3em 3em;
   max-width: 999px;
   margin: 0 auto;
   margin-top: 30px;
}

h1 {
   text-align: center
}

li {
   list-style-type: none;
}

p {
   display: block;
   -webkit-margin-before: 1em;
   -webkit-margin-after: 1em;
   -webkit-margin-start: 0px;
   -webkit-margin-end: 0px;
}

header {
   font-size: 0;
   background-color: #fff;
   border-bottom: 1px solid #d0d4d9;
   box-shadow: 0px 1px 1px #d0d4d9;
   position: fixed;
   top: 0;
   right: 0;
   left: 0;
   overflow: hidden;
   height: 76px;
   line-height: 26px;
   z-index: 99;
}

header > div {
   height: 46px;
   margin: 13px auto;
   min-width: 600px;
   max-width: 1200px;
   overflow: hidden;
   position: relative;
   text-align: center;
}

header img {
   height: 26px;
   margin: 10px;
}

header a {
   color: #2ea8ed;
   cursor: pointer;
   font-size: 14px;
   position: absolute;
   top: 0;
   right: 115px;
   line-height: 46px;
}

header a:hover {
   color: #2997d5;
}

header a:active {
   color: #1579b0;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/privacy/privacy.component.css"],"names":[],"mappings":"AAAA;GACG,oBAAoB;GACpB,gBAAgB;GAChB,cAAc;GACd,gBAAgB;AACnB;;AAEA;GACG;AACH;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,cAAc;GACd,0BAA0B;GAC1B,yBAAyB;GACzB,yBAAyB;GACzB,uBAAuB;AAC1B;;AAEA;GACG,YAAY;GACZ,sBAAsB;GACtB,gCAAgC;GAChC,+BAA+B;GAC/B,eAAe;GACf,MAAM;GACN,QAAQ;GACR,OAAO;GACP,gBAAgB;GAChB,YAAY;GACZ,iBAAiB;GACjB,WAAW;AACd;;AAEA;GACG,YAAY;GACZ,iBAAiB;GACjB,gBAAgB;GAChB,iBAAiB;GACjB,gBAAgB;GAChB,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,YAAY;AACf;;AAEA;GACG,cAAc;GACd,eAAe;GACf,eAAe;GACf,kBAAkB;GAClB,MAAM;GACN,YAAY;GACZ,iBAAiB;AACpB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB","sourcesContent":["#policy_block {\n   padding: 1em 3em 3em;\n   max-width: 999px;\n   margin: 0 auto;\n   margin-top: 30px;\n}\n\nh1 {\n   text-align: center\n}\n\nli {\n   list-style-type: none;\n}\n\np {\n   display: block;\n   -webkit-margin-before: 1em;\n   -webkit-margin-after: 1em;\n   -webkit-margin-start: 0px;\n   -webkit-margin-end: 0px;\n}\n\nheader {\n   font-size: 0;\n   background-color: #fff;\n   border-bottom: 1px solid #d0d4d9;\n   box-shadow: 0px 1px 1px #d0d4d9;\n   position: fixed;\n   top: 0;\n   right: 0;\n   left: 0;\n   overflow: hidden;\n   height: 76px;\n   line-height: 26px;\n   z-index: 99;\n}\n\nheader > div {\n   height: 46px;\n   margin: 13px auto;\n   min-width: 600px;\n   max-width: 1200px;\n   overflow: hidden;\n   position: relative;\n   text-align: center;\n}\n\nheader img {\n   height: 26px;\n   margin: 10px;\n}\n\nheader a {\n   color: #2ea8ed;\n   cursor: pointer;\n   font-size: 14px;\n   position: absolute;\n   top: 0;\n   right: 115px;\n   line-height: 46px;\n}\n\nheader a:hover {\n   color: #2997d5;\n}\n\nheader a:active {\n   color: #1579b0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
